import { Injectable } from '@angular/core';
import { Product } from '../../domain/product';
import { PRODUCT_DESCRIPTION_03, PRODUCT_DESCRIPTION_04, PRODUCT_DESCRIPTION_05, PRODUCT_DESCRIPTION_06, PRODUCT_DESCRIPTION_07, PRODUCT_DESCRIPTION_08 } from '../../shared/constants';
import PRODUCT_DETAIL_03 from './content/sales.content.html';
import PRODUCT_DETAIL_04 from './content/marketing.content.html';
import PRODUCT_DETAIL_05 from './content/support.content.html';
import PRODUCT_DETAIL_06 from './content/notes.content.html';
import PRODUCT_DETAIL_07 from './content/action-items.content.html';
import PRODUCT_DETAIL_08 from './content/drive.content.html';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor() { }


  getProducts() {
    var productSales = new Product()
    productSales.slug = "bunnycrm-sales"
    productSales.name = "BunnyCRM Sales"
    productSales.title = "BunnyCRM Sales — Lead Capture & Pipeline Automation"
    productSales.metaDescription = "Capture leads automatically, score them by fit and intent, and move deals through a clear pipeline with BunnyCRM Sales."
    productSales.keywords = "sales pipeline software, lead management CRM, sales automation software, deal tracking software, lead scoring tool, sales CRM, automated sales follow-ups"
    productSales.description = PRODUCT_DESCRIPTION_03
    productSales.details = PRODUCT_DETAIL_03
    productSales.photo01 = "images/products/sales.svg"
    productSales.photo01Alt = "BunnyCRM Sales — pipeline and trend-line icon"
    productSales.link = "https://bunnycrm.com"

    var productMarketing = new Product()
    productMarketing.slug = "bunnycrm-marketing"
    productMarketing.name = "BunnyCRM Marketing"
    productMarketing.title = "BunnyCRM Marketing — Email Marketing Automation"
    productMarketing.metaDescription = "Run campaigns end-to-end with BunnyCRM Marketing — email workflows, audience segmentation, and lead nurturing on the same contact record your sales team uses."
    productMarketing.keywords = "email marketing automation, marketing automation software, lead nurturing software, audience segmentation tool, email workflow builder, campaign management software, marketing automation"
    productMarketing.description = PRODUCT_DESCRIPTION_04
    productMarketing.details = PRODUCT_DETAIL_04
    productMarketing.photo01 = "images/products/marketing.svg"
    productMarketing.photo01Alt = "BunnyCRM Marketing — envelope, broadcast arcs, and audience icon"
    productMarketing.link = "https://bunnycrm.com"

    var productSupport = new Product()
    productSupport.slug = "bunnycrm-support"
    productSupport.name = "BunnyCRM Support"
    productSupport.title = "BunnyCRM Support — Helpdesk & Ticketing Built Into Your CRM"
    productSupport.metaDescription = "Manage tickets, live chat, and a self-service knowledge base on the same contact records your sales and marketing teams already use."
    productSupport.keywords = "helpdesk software, customer support ticketing system, live chat software, knowledge base software, team helpdesk, customer service software, support ticket management"
    productSupport.description = PRODUCT_DESCRIPTION_05
    productSupport.details = PRODUCT_DETAIL_05
    productSupport.photo01 = "images/products/support.svg"
    productSupport.photo01Alt = "BunnyCRM Support — headset and chat-bubble icon"
    productSupport.link = "https://bunnycrm.com"

    var productNotes = new Product()
    productNotes.slug = "bunnycrm-notes"
    productNotes.name = "BunnyCRM Notes"
    productNotes.title = "BunnyCRM Notes — Markdown Notes Linked to Your Customer Records"
    productNotes.metaDescription = "Keep personal or record-linked notes in markdown, private to you and searchable in seconds — all inside BunnyCRM."
    productNotes.keywords = "markdown notes app, CRM notes software, record-linked notes, private notes, personal notes app, business notes app, note search, customer record notes"
    productNotes.description = PRODUCT_DESCRIPTION_06
    productNotes.details = PRODUCT_DETAIL_06
    productNotes.photo01 = "images/products/notes.svg"
    productNotes.photo01Alt = "BunnyCRM Notes — note card and pen icon"
    productNotes.link = "https://bunnycrm.com"

    var productActionItems = new Product()
    productActionItems.slug = "bunnycrm-action-items"
    productActionItems.name = "BunnyCRM Action Items"
    productActionItems.title = "BunnyCRM Action Items — Follow-Up & Task Tracking for Teams"
    productActionItems.metaDescription = "Turn follow-ups into tracked tasks with clear owners, due dates, and status. BunnyCRM Action Items keeps commitments from notes, tickets, and deals from falling through."
    productActionItems.keywords = "action item tracker, follow-up tracking software, task management for CRM, team task tracking, shared to-do list, deal follow-up reminders, ticket action items, CRM task management"
    productActionItems.description = PRODUCT_DESCRIPTION_07
    productActionItems.details = PRODUCT_DETAIL_07
    productActionItems.photo01 = "images/products/action-items.svg"
    productActionItems.photo01Alt = "BunnyCRM Action Items — checklist and reminder-bell icon"
    productActionItems.link = "https://bunnycrm.com"

    var productDrive = new Product()
    productDrive.slug = "bunnycrm-drive"
    productDrive.name = "BunnyCRM Drive"
    productDrive.title = "BunnyCRM Drive — Secure Cloud File Storage for Teams"
    productDrive.metaDescription = "Store, organize, and access files from anywhere with BunnyCRM Drive — attached to the customer record they belong to, and reusable across sales, marketing, and support."
    productDrive.keywords = "cloud file storage, business file storage, document management software, CRM file attachments, secure online storage, team file storage, file version history, online storage for teams"
    productDrive.description = PRODUCT_DESCRIPTION_08
    productDrive.details = PRODUCT_DETAIL_08
    productDrive.photo01 = "images/products/drive.svg"
    productDrive.photo01Alt = "BunnyCRM Drive — folder and cloud-upload icon"
    productDrive.link = "https://bunnycrm.com"

    return [productSales, productMarketing, productSupport, productNotes, productActionItems, productDrive]
  }
}
